import styled from 'styled-components'
import { HeadingReset } from '@chegg-wt/core/theme/sunkist/resets'
import { Heading3, BodyLarge } from '@chegg-wt/core/theme/sunkist/typography'

export const EmptyMessage = styled.div`
  text-align: center;
  margin-top: 72px;
  margin-bottom: 72px;
`

export const Header = styled.h5`
  ${HeadingReset};
  ${Heading3};
`

export const Body = styled.p`
  ${BodyLarge};
`
